import { render, staticRenderFns } from "./zhprescription.vue?vue&type=template&id=729f0f05&"
import script from "./zhprescription.vue?vue&type=script&lang=js&"
export * from "./zhprescription.vue?vue&type=script&lang=js&"
import style0 from "./zhprescription.vue?vue&type=style&index=0&id=729f0f05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports